import styled from 'styled-components'

export const ButtonL = styled.button`
    border: none;
    background-color: #F35408;
    color: #F0EAE1 !important;
    height: 2.3rem;
    width: 6rem;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 500;
    font-size: 16px !important;;
    line-height: 19px;
    color: #95A6B5;
    text-transform: capitalize;

    &:hover {
        box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.3);
    }

`